import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
function ApprovalQueue() {
    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState([]);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [actionType, setActionType] = useState("");
    const [remarks, setRemarks] = useState("");
    useEffect(() => {
        getApprovalQueue();
    }, []);
    const getApprovalQueue = () => {
        setLoading(true);
        axios
            .get(baseUrl + "workflow-approval-queue/")
            .then((res) => {
                setTransactions(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire("Error", "Unable to load approval queue", "error");
            });
    };
    const openActionModal = (transaction, action) => {
        setSelectedTransaction(transaction);
        setActionType(action);
        setRemarks("");
        setShowModal(true);
    };
    const closeModal = () => {
        setShowModal(false);
        setSelectedTransaction(null);
    };
    const submitAction = () => {
        const data = {
            transaction_id: selectedTransaction.id,
            action: actionType,
            remarks: remarks,
            action_by: userName,
            ip_add: ipAddress
        };
        axios
            .post(baseUrl + "workflow-action/", data)
            .then(() => {
                Swal.fire("Success", `Transaction ${actionType} successfully`, "success");
                closeModal();
                getApprovalQueue();
            })
            .catch(() => {
                Swal.fire("Error", "Unable to process action", "error");
            });
    };
    return (<div className="container-fluid mt-3">


        <div className="card shadow">


            <div className="card-header bg-primary text-white">

                <h5 className="mb-0">

                    Pending Approvals

                </h5>

            </div>


            <div className="card-body">


                {transactions.length === 0 && (<div className="alert alert-warning">

                    No Pending Approvals

                </div>)}


                <div className="row">


                    {transactions.map((item) => (<div
                        key={item.id}
                        className="col-lg-3 col-md-4 col-sm-6 mb-4"
                    >


                        <div
                            className="card app-card shadow-sm"
                        >


                            <div className="app-card-header">


                                🔔 {item.document_type}


                            </div>


                            <div className="app-card-body">


                                <p>

                                    <strong>
                                        Document ID:
                                    </strong>

                                    {" "}

                                    {item.document_id} - {item.document_type}

                                </p>


                                <p>

                                    <strong>
                                        Workflow:
                                    </strong>

                                    {" "}

                                    {item.workflow.workflow_name}

                                </p>


                                <p>

                                    <strong>
                                        Current Stage:
                                    </strong>

                                    {" "}

                                    {item.current_stage.stage_name}

                                </p>


                                <p>

                                    <strong>
                                        Created By:
                                    </strong>

                                    {" "}

                                    {item.created_by.username}

                                </p>


                                <p>

                                    <strong>
                                        Status:
                                    </strong>

                                    {" "}


                                    <span className="badge bg-warning">

                                                {item.status}

                                            </span>


                                </p>


                            </div>


                            <div className="app-card-footer">


                                <button

                                    className="btn btn-success w-100 mb-2"

                                    onClick={() => openActionModal(item, "APPROVED")}

                                >

                                    ✅ Approve

                                </button>


                                <button

                                    className="btn btn-danger w-100 mb-2"

                                    onClick={() => openActionModal(item, "REJECTED")}

                                >

                                    ❌ Reject

                                </button>


                                <button

                                    className="btn btn-warning w-100"

                                    onClick={() => openActionModal(item, "SEND_BACK")}

                                >

                                    ↩ Send Back

                                </button>


                            </div>


                        </div>


                    </div>))}


                </div>


            </div>


        </div>


        {showModal && (<div

            className="modal fade show"

            style={{
                display: "block", backgroundColor: "rgba(0,0,0,.5)"
            }}

        >


            <div className="modal-dialog modal-dialog-centered">


                <div className="modal-content">


                    <div className="modal-header">


                        <h5 className="modal-title">


                            {actionType}


                        </h5>


                        <button

                            className="btn-close"

                            onClick={closeModal}

                        />


                    </div>


                    <div className="modal-body">


                        <label>

                            Remarks

                        </label>


                        <textarea

                            className="form-control"

                            rows="4"

                            value={remarks}

                            onChange={(e) => setRemarks(e.target.value)}

                        />


                    </div>


                    <div className="modal-footer">


                        <button

                            className="btn btn-secondary"

                            onClick={closeModal}

                        >

                            Cancel

                        </button>


                        <button

                            className="btn btn-primary"

                            onClick={submitAction}

                        >

                            Submit

                        </button>


                    </div>


                </div>


            </div>


        </div>)}


    </div>);
}
export default ApprovalQueue;